import {
	cloudHealthColorAlertFormatter,
	dateTimeFormatter,
	CloudServiceNowButton, integerFormatter
} from "../../gridFormatters";

export const cloudHealthAlerts = [
	{
      field: "id",
        headerName: 'ID'
    },
	{
		"field": "device_type_description",
		"headerName": "Cloud Type",
	},
	{
		"field": "name",
		"headerName": "Alert",
	},
	{
		"field": "severity",
		"headerName": "Severity",
		"cellRenderer": cloudHealthColorAlertFormatter,
	},
	{
		"field": "affected_resource",
		"headerName": "Affected Resource",
	},
	{
		"field": "alert_condition",
		"headerName": "Alert Condition",
	},
	{
		"field": "user_response",
		"headerName": "User Response",
	},
	{
		"field": "fire_time",
		"headerName": "Fire Time",
		"cellRenderer": dateTimeFormatter,
	},
	{
		"field": "subscription",
		"headerName": "Subscription",
	},

	{
		"field": "resource_group",
		"headerName": "Resource Group",
	},
	{
		"field": "description",
		"headerName": "Description",
	},
	{
        "field": "incident_id",
        "headerName": "Service Now",
        "cellRenderer": CloudServiceNowButton
    }
]